export interface Category {
  id: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: "thriller",
    name: "惊悚",
    icon: "ri-pulse-line",
    description: "心跳与寂静的博弈，最适合在午夜把神经绷到极致的类型。",
  },
  {
    id: "horror",
    name: "恐怖",
    icon: "ri-ghost-line",
    description: "从声音到画面，专为黑暗中独处的人准备的一场漫长低语。",
  },
  {
    id: "drama",
    name: "剧情",
    icon: "ri-film-line",
    description: "慢下来的故事与真实的人，配得上一杯深夜的热饮。",
  },
  {
    id: "mystery",
    name: "悬疑",
    icon: "ri-search-eye-line",
    description: "线索藏在细节里，越接近凌晨越让人舍不得按下暂停。",
  },
  {
    id: "sci-fi",
    name: "科幻",
    icon: "ri-planet-line",
    description: "霓虹、雨夜与未来，让午夜的城市变成另一个星球。",
  },
  {
    id: "crime",
    name: "犯罪",
    icon: "ri-shield-line",
    description: "城市不睡，正义也没休息，一场属于夜的追与逃。",
  },
  {
    id: "romance",
    name: "爱情",
    icon: "ri-heart-3-line",
    description: "那些说不出口的话，常常在凌晨四点才有勇气写下。",
  },
  {
    id: "comedy",
    name: "黑色幽默",
    icon: "ri-emotion-laugh-line",
    description: "在荒诞与微笑之间，深夜最适合的清醒剂。",
  },
];

export const genreOptions = ["惊悚", "恐怖", "剧情", "悬疑", "科幻", "犯罪", "爱情", "黑色幽默"];
export const regionOptions = ["中国大陆", "美国", "日本", "韩国", "中国香港", "欧洲"];
export const yearOptions = ["2024", "2023", "2022", "2021"];
export const newsCategories = ["全部", "影评", "新闻", "专题", "访谈"];